import { render, staticRenderFns } from "./TaskStatusReminderForm.vue?vue&type=template&id=1e2cf315"
import script from "./TaskStatusReminderForm.vue?vue&type=script&lang=js"
export * from "./TaskStatusReminderForm.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports